export default __webpack_public_path__ + "assets/images/cad6e73a1572ee2c2d238ddb73d89793.svg";